<script setup lang="ts">
import { computed, ref } from "vue";
import { bmIconName } from "@/components/controls/bmIconMap";

const passwordIsVisible = ref(false);

const type = computed(() => (passwordIsVisible.value ? "text" : "password"));

const appendIcon = computed(() => {
  if (props.disableAppendIcon) {
    return undefined;
  }

  return passwordIsVisible.value
    ? bmIconName("Visibility")
    : bmIconName("VisibilityOff");
});

const props = defineProps<{
  value: string;
  disableAppendIcon?: boolean;
}>();

const emit = defineEmits<{
  (event: "update:value", value: string): void;
}>();
</script>

<template>
  <bm-text
    :value="value"
    v-bind="$attrs"
    :type="type"
    :append-icon="appendIcon"
    @update:value="emit('update:value', $event)"
    @click:append="passwordIsVisible = !passwordIsVisible"
  />
</template>
